module.exports = {
      id: "analysis-usage",
      viewBox: "0 0 32 19.2",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#analysis",
      toString: function () {
        return this.url;
      }
    }